import { useCallback, useEffect } from 'react';
import { createGlobalState, useLocalStorage } from 'react-use';

const useGlobalMostRecentViewedNoteDateState = createGlobalState<string | null>(null);

export function useMostRecentViewedNoteDate() {
  // Initial value comes from local storage
  // Use this to populate a piece of global state
  const [valueFromLocalStorage, setValueInLocalStorage] = useLocalStorage<string | null>('on-release-note-date', null);

  const [stateValue, setStateValue] = useGlobalMostRecentViewedNoteDateState();

  // Default the state value to the value from localstorage
  useEffect(() => {
    if (stateValue == null && valueFromLocalStorage != null) {
      setStateValue(valueFromLocalStorage);
    }
  }, [valueFromLocalStorage, stateValue, setStateValue]);

  const setMostRecentViewedNoteDate = useCallback(
    (value: string) => {
      setStateValue(value);
      setValueInLocalStorage(value);
    },
    [setValueInLocalStorage, setStateValue]
  );

  // as const to treat it as a tuple rather than a mixed array
  return [stateValue || valueFromLocalStorage || null, setMostRecentViewedNoteDate] as const;
}
